var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckEncuesta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 33C18.6668 33 20.8124 32.5732 22.8143 31.744C24.8162 30.9148 26.6351 29.6994 28.1673 28.1673C29.6994 26.6351 30.9148 24.8162 31.744 22.8143C32.5732 20.8124 33 18.6668 33 16.5C33 14.3332 32.5732 12.1876 31.744 10.1857C30.9148 8.18385 29.6994 6.3649 28.1673 4.83274C26.6351 3.30057 24.8162 2.08519 22.8143 1.25599C20.8124 0.426785 18.6668 -3.2288e-08 16.5 0C12.1239 6.52086e-08 7.92709 1.73839 4.83274 4.83274C1.73839 7.92709 0 12.1239 0 16.5C0 20.8761 1.73839 25.0729 4.83274 28.1673C7.92709 31.2616 12.1239 33 16.5 33ZM16.0747 23.1733L25.2413 12.1733L22.4253 9.82667L14.542 19.2848L10.4628 15.2038L7.8705 17.7962L13.3705 23.2962L14.7895 24.7152L16.0747 23.1733Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckEncuesta);
export default __webpack_public_path__ + "static/media/checkEncuesta.ee479159de430df0f31aa1ec90f5ef1f.svg";
export { ForwardRef as ReactComponent };